module.exports = __webpack_public_path__ + "static/media/pa.943e160a.svg";